import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-foreground py-12">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-8 text-white/80">
          <div>
            <h3 className="font-serif text-lg font-semibold text-white mb-2">
              Praxis Sorgenfrey
            </h3>
            <p className="font-sans text-sm">Christine Sorgenfrey-Schoof</p>
            <p className="font-sans text-sm">Lisa Sorgenfrey</p>
          </div>
          <div>
            <h4 className="font-sans text-sm font-semibold text-white mb-2 uppercase tracking-wider">
              Kontakt
            </h4>
            <p className="font-sans text-sm">04163 8699614</p>
            <p className="font-sans text-sm">Psychotherapie@sorgenfrey.de</p>
            <p className="font-sans text-sm">Thuner Straße 4, 21680 Stade</p>
          </div>
          <div>
            <h4 className="font-sans text-sm font-semibold text-white mb-2 uppercase tracking-wider">
              Rechtliches
            </h4>
            <ul className="space-y-1">
              <li><Link to="/impressum" className="font-sans text-sm hover:text-white transition-colors">Impressum</Link></li>
              <li><Link to="/datenschutz" className="font-sans text-sm hover:text-white transition-colors">Datenschutz</Link></li>
              <li>
                <button
                  onClick={() => window.openCookieSettings?.()}
                  className="font-sans text-sm text-white/80 hover:text-white transition-colors"
                >
                  Cookie-Einstellungen
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/20 mt-10 pt-6 text-center">
          <p className="font-sans text-xs text-white/70">
            © {new Date().getFullYear()} Praxis Sorgenfrey. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
